export var BrandOrderSource;
(function (BrandOrderSource) {
    BrandOrderSource["MARKETPLACE"] = "MARKETPLACE";
    BrandOrderSource["ELEVATE"] = "ELEVATE";
    BrandOrderSource["TRADESHOW"] = "TRADESHOW";
    BrandOrderSource["MARKETPLACE_PAID_PLACEMENT"] = "MARKETPLACE_PAID_PLACEMENT";
})(BrandOrderSource || (BrandOrderSource = {}));
